import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

/**
 * Filtra os registros classificados como vermelhos.
 * @param {Array} cadastros Lista de registros
 * @returns {Array} Registros com dados desatualizados
 */
export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    let diff = utils.methods.diffDays(item.dt_dados)
    if (diff > 8 || item.dt_dados == null) {
      return true
    }
    return false
  })
  return filtro
}

/**
 * Filtra os registros classificados como verdes.
 * @param {Array} cadastros Lista de registros
 * @returns {Array} Registros com dados atualizados
 */
export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    let diff = utils.methods.diffDays(item.dt_dados)
    if (diff > 8 || item.dt_dados == null) {
      return false
    }
    return true
  })
  return filtro
}

/**
 * Gera o relatório em PDF
 *
 * @param {*} cadastros
 * @param {Array}
 */
export function generatePdf(cadastros) {
  const titlePdf = 'Envio APP ACS PEC'
  const titlePdfSave = utils.methods.titlePdf(titlePdf)
  const descriptionPdf = 'Última visita do ACS encontrada no PEC'
  const headersPdf = [
    'PROFISSIONAL ACS',
    'UNIDADE DE SAÚDE',
    'ÚLTIMA VISITA',
    'MICROÁREA',
    'EQUIPE',
    'MUNICÍPIO',
  ]

  const dataPdf = cadastros.map((item) => {
    const formatDate = item.dt_dados
      ? utils.methods.formatDate(item.dt_dados)
      : '+30 dias'

    const documentoParts = []
    if (item.nu_cpf) documentoParts.push(`CPF ${item.nu_cpf}`)
    if (item.nu_cns) documentoParts.push(`CNS ${item.nu_cns}`)

    return {
      no_profissional: item.no_profissional,
      no_unidade_saude: item.no_unidade_saude,
      dt_dados: formatDate,
      qtd_visitas_acs: item.qtd_visitas_acs,
      qtd_visitas_equipe: item.qtd_visitas_equipe,
      qtd_visitas_municipio: item.qtd_visitas_municipio,
    }
  })

  const doc = new jsPDF(utils.methods.encryptionPdf())
  const table = utils.methods.createTablePdf(dataPdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      // Data atual
      const dataAtual = new Date().toLocaleDateString('pt-BR')
      doc.setFontSize(12)
      verticalPosition += 6
      doc.text(`Data: ${dataAtual}`, 15, verticalPosition)

      verticalPosition += 6

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: ({ row, section }) => {
          if (section === 'head') doc.setTextColor(0, 0, 0)
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  'Profissional acs': 'no_profissional',
  'Unidade de saúde': 'no_unidade_saude',
  'Última visita': {
    field: 'dt_dados',
    callback: (value) => {
      if (value !== null && value !== undefined && value !== '') {
        return utils.methods.formatDate(value)
      }
      return '+30 dias'
    },
  },
  Microárea: 'qtd_visitas_acs',
  Equipe: 'qtd_visitas_equipe',
  Município: 'qtd_visitas_municipio',
}
